import { getShape, type PieceData, PieceType } from './Piece';

export class PieceBag {
  private lastTwo: PieceType[] = [];

  /**
   * Generate a round of 3 pieces.
   */
  generateRound(): PieceData[] {
    const pieces: PieceData[] = [];

    for (let i = 0; i < 3; i++) {
      const type = this.pickType();
      const shape = getShape(type);
      pieces.push({
        shape,
        colorIndex: this.randomColorIndex(),
        rows: shape.length,
        cols: shape[0].length,
      });
    }

    return pieces;
  }

  /**
   * Pick a random piece type, never the same shape 3 times in a row.
   */
  private pickType(): PieceType {
    const types: PieceType[] = [
      PieceType.SQUARE,
      PieceType.I,
      PieceType.L,
      PieceType.T,
      PieceType.S,
      PieceType.Z,
      PieceType.SMALL,
    ];

    // If the last two picks were identical, exclude that type
    const banned = this.lastTwo.length === 2 && this.lastTwo[0] === this.lastTwo[1]
      ? this.lastTwo[0]
      : null;

    const available = banned !== null
      ? types.filter((t) => t !== banned)
      : [...types];

    const picked = available[Math.floor(Math.random() * available.length)];

    this.lastTwo.push(picked);
    if (this.lastTwo.length > 2) {
      this.lastTwo.shift();
    }

    return picked;
  }

  private randomColorIndex(): number {
    return Math.floor(Math.random() * 7);
  }
}